export const ExistAutomaticHeight = (payload: any) => payload && payload.automaticHeight

export const ExistRedrawCharts = (payload: any) => payload && payload.redrawCharts

export const ExistUrl = (payload: any) => payload && payload.url

export const ReinitCarousel = (payload: any) => payload && payload.reinitCarousel

export const TriggerCampaignChange = (payload: any) => payload && payload.triggerCampaignChange

export const HideLoader = (payload: any) => payload && payload.hideLoader
